module.exports = __webpack_public_path__ + "img/first.630d63cf.jpg";